var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#F4F4F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1025_18578)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6836 24.7656C34.4682 24.7656 34.7707 30.0532 34.7707 32.3518C34.7707 35.4896 31.2863 37.9722 28.1483 37.9722H23.6517C20.5139 37.9722 17.0293 35.4893 17.0293 32.3518C17.0293 30.0535 17.3319 24.7656 23.1164 24.7656H28.6839H28.6836ZM26.6655 33.6541H25.0275C25.0109 32.2154 25.1634 31.7244 26.3352 30.7689C26.8292 30.3694 27.5132 29.9435 27.5132 29.2414C27.5132 28.3941 26.7263 27.975 25.961 27.975C24.9442 27.975 24.3824 28.6102 24.1797 29.5604L22.5304 29.3494C22.6416 27.556 24.2074 26.603 25.8858 26.603C27.4936 26.603 29.2676 27.4922 29.2676 29.2942C29.2676 30.4245 28.2898 31.2041 27.4936 31.863C26.754 32.4789 26.643 32.6854 26.6654 33.6539L26.6655 33.6541ZM25.0275 36.0619V34.2685H26.6655V36.0619H25.0275ZM25.8997 14.0135C28.6214 14.0135 30.8284 16.2205 30.8284 18.9422C30.8284 21.6624 28.6214 23.8677 25.8997 23.8677C23.1785 23.8677 20.9715 21.6624 20.9715 18.9422C20.9715 16.2205 23.1785 14.0135 25.8997 14.0135Z",
    fill: "#0061C0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1025_18578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7853,
    height: 24,
    fill: "white",
    transform: "translate(17 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.10fac2528d80be5e1564a8d64e3f0577.svg";
export { ForwardRef as ReactComponent };